export default function getCouponDiscount(price, { amountOff, percentOff }) {
  let discount = 0;

  if (amountOff || percentOff) {
    if (amountOff) {
      discount = amountOff;
    }

    if (percentOff) {
      discount = price - price * (1 - percentOff / 100);
    }
  }

  return discount;
}
